export default __webpack_public_path__ + "a5fed691bc16e8bd6c02272e82ab8bfe.png";